// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadOptionCard-cls1_vSO","cls2":"DownloadOptionCard-cls2_kLR DownloadOptionCard-cls1_vSO"};